/** Update generated copy in older saved plans without changing learner-entered text. */
export function currentPlanCopy(assumption: string): string {
  return assumption.replace(/^The local Bloom It engine\b/, 'The local blomit engine')
}
